import { InputNumber } from 'primeng/inputnumber';

/**
 * PrimeNG InputNumber cancels the browser paste and inserts the clipboard
 * itself. Lighthouse treats that preventDefault as a blocked paste.
 * Leave the default action, then parse the field once the text is in place.
 */
export function allowInputNumberPaste(): void {
  const proto = InputNumber.prototype;
  if (proto.onPaste.name === 'allowPaste') {
    return;
  }

  proto.onPaste = function allowPaste(this: InputNumber, event: ClipboardEvent): void {
    if (this.disabled || this.readonly) {
      return;
    }

    const input = this.input?.nativeElement as HTMLInputElement | undefined;
    if (!input) {
      return;
    }

    const previous = input.value;
    setTimeout(() => {
      const parsed = this.parseValue(input.value);
      if (parsed == null || parsed === '-') {
        input.value = previous;
        return;
      }

      const validated = this.validateValue(parsed);
      this.updateValue(event, String(validated), null, 'insert');
    }, 0);
  };
}
